import { connect } from 'react-redux'
import { replace } from 'react-router-redux'

import { fetchServicing, rescheduleServicing } from '../../actions/servicings'
import { fetchWorkOrder } from '../../actions/work-orders'

import ServicingRedoReasonForm from '../../components/servicings/servicing-redo-reason-form'

function mapStateToProps (state, ownProps) {
  const servicing = state.servicings[ownProps.params.servicingId]

  if (!servicing) return { loading: true }

  return { servicing }
}

function mapDispatchToProps (dispatch, ownProps) {
  dispatch(fetchServicing(ownProps.params.servicingId))

  return {
    handleClose () {
      dispatch(replace(`summaries/${ownProps.params.workSummaryId}`))
    },

    onSubmit (data) {
      dispatch(rescheduleServicing(ownProps.params.servicingId, data))
        .then(() => dispatch(fetchWorkOrder(ownProps.params.workSummaryId)))
        .then(() => dispatch(replace(`summaries/${ownProps.params.workSummaryId}`)))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ServicingRedoReasonForm)



// WEBPACK FOOTER //
// ./src/containers/servicings/rescheduled-servicing-redo-reason-form-container.js